import { NLPurchaseProduct } from "@models/Models";
import { kAppConstants } from "./AppConstants";

export const yearlyPlan: NLPurchaseProduct = {
	price_id: kAppConstants.appStage === "production" ? "price_1R6RweGM9IN4MI0rAZJXhZ1A" : "price_1P5nXIGM9IN4MI0rOj7SkRIk",
	product_name: "Yearly Plan",
	monthly_price: "$3.33",
	total_price: "$39.99",
	trial_days: 7,
	term: "year",
	badge: "7 DAYS FREE",
};

export const monthlyPlan: NLPurchaseProduct = {
	price_id: kAppConstants.appStage === "production" ? "price_1R6RyxGM9IN4MI0r1Dbqf20d" : "price_1P5nWzGM9IN4MI0r2hLhUNQw",
	product_name: "Monthly Plan",
	monthly_price: "$4.99",
	total_price: "$4.99",
	term: "month",
};
